import { SanityPerson } from '../../types/generated/graphql-types'
import { PersonLinkProps } from '../components/PersonLink'
import { peopleHoverColorMap } from '../constants/peopleHoverColorMap'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImageProps } from '../utilities/imagePropUtils'

export const mapSanityPersonToPersonLinkProps = (
  person: SanityPerson
): PersonLinkProps => ({
  url: person.path ?? '',
  name: person.title ?? '',
  title: person.workTitle ?? '',
  image: validImage(person.portrait)
    ? getImageProps(person.portrait, Presets.thumbnail)
    : null,
  hoverBgColor: person.team?.[0]
    ? peopleHoverColorMap[person.team[0]]
    : peopleHoverColorMap['default'],
})
